import * as types from './types';
import { setGroupMessagesWithResponseMessage } from './utils';

const initialState = {
  messages: [],
  groupMessages: [],
  loading: '',
  leadName: '', // Publishername se debe sacar cuando pasemos el seeker info a redux
  disabledButton: true,
  filesToUpload: [],
  showModal: false,
  fileLoading: '',
  snackBarAdjuntos: {}
};

const MessageSeekerReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_SEEKER_MESSAGES:
      state.loading = 'loading';
      state.groupMessages = [];
      state.messages = [];
      return { ...state };
    case types.FETCH_SEEKER_MESSAGES_SUCCEEDED:
      state.loading = 'loaded';
      state.groupMessages = action.payload.groupMessages;
      state.messages = action.payload.messages;
      return { ...state };
    case types.FETCH_SEEKER_MESSAGES_FAILED:
      state.loading = 'error';
      return { ...state };

    case types.FETCH_SEEKER_MESSAGES_RESET:
      state.loading = 'loading';
      state.groupMessages = [];
      state.messages = [];
      return { ...state };

    case types.ADD_SEEKER_MESSAGE:
      state.messages.push(action.payload);
      setGroupMessagesWithResponseMessage(state.messages)(groupMessages => {
        state.groupMessages = groupMessages;
      });
      return { ...state };
    case types.ADD_SEEKER_MESSAGE_SUCCEEDED:
      state.messages.map(m => {
        if (m.message_id === action.payload.message_id) {
          m.request = false;
        }
        return m;
      });
      setGroupMessagesWithResponseMessage(state.messages)(groupMessages => {
        state.groupMessages = groupMessages;
      });
      return { ...state };

    case types.ADD_FILE_SUCCEEDED:
      state.filesToUpload.push(action.payload[0]);
      state.fileLoading = '';
      return { ...state };

    case types.ADD_FILE:
      state.fileLoading = 'loading';
      return { ...state };

    case types.REMOVE_FILE:
      state.filesToUpload.splice(action.payload, 1);
      return { ...state };

    case types.RESET_FILES:
      return {
        ...state,
        filesToUpload: []
      };

    case types.ERROR_UPLOAD:
      state.fileLoading = 'error';
      return { ...state };

    case types.REVERT_ERROR:
      state.fileLoading = '';
      return { ...state };

    case types.SHOW_SNACKBAR:
      return {
        ...state,
        snackBarAdjuntos: action.payload
      };
    case types.HIDE_SNACKBAR:
      return {
        ...state,
        snackBarAdjuntos: { ...state.snackBarAdjuntos, show: false }
      };

    case types.SHOW_MODAL:
      return {
        ...state,
        showModal: true
      };
    default:
      return { ...state };
  }
};

export default MessageSeekerReducer;
